import { AbstractControl, ValidationErrors } from '@angular/forms';
/**
 * @description
 * This method is used to validate if a password is secure
 * @param {string} controlName (formcontrol name)
 * @returns {null | ValidationErrors}
 */
export function passwordSecureValidator(controlName: string) {
  return (ctrl: AbstractControl): null | ValidationErrors => {
    if (!ctrl.get(controlName)) {
      return {
        passwordSecure: 'Invalid control name',
      };
    }
    const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[+/=,;µ:()#@$!%*?&àé~'"`|^_ç°€<>])[A-Za-z\d+/=,;µ:()#@$!%*?&àé~.'"`|^_ç°€<>]*$/m);
    const control = ctrl.get(controlName)!.value;

    return regex.test(control)
      ? null
      : {
          passwordSecure: {
            controlName: controlName,
            passwordSecure: control,
          },
        };
  };
}
